export * from "./banner";
export * from "./about";
export * from "./waare";
export * from "./product";
export * from "./estimation";
export * from "./solution";
export * from "./sustain";
export * from "./innovation";
export * from "./home-form";
export * from "./resource";
export * from "./product_category";
export * from "./product_highlights";
export * from "./product_certifications";
export * from "./our_resource";
export * from "./career";
export * from "./recognitions";
export * from "./testimonials";
export * from "./clients";
export * from "./space";
export * from "./waaree_stocks";

